import React from 'react';

// Laksh Logo - Mark only (icon)
export const LakshMark = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 200 200" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="200" fill="#06100A" rx="24"/>
    <g transform="translate(100,100)">
      <circle r="66" fill="none" stroke="#EF9F27" strokeWidth="7"/>
      <circle r="44" fill="none" stroke="#1D9E75" strokeWidth="4"/>
      <line x1="0" y1="-66" x2="0" y2="-48" stroke="#EF9F27" strokeWidth="6.5" strokeLinecap="round"/>
      <line x1="0" y1="48" x2="0" y2="66" stroke="#EF9F27" strokeWidth="6.5" strokeLinecap="round"/>
      <line x1="-66" y1="0" x2="-48" y2="0" stroke="#EF9F27" strokeWidth="6.5" strokeLinecap="round"/>
      <line x1="48" y1="0" x2="66" y2="0" stroke="#EF9F27" strokeWidth="6.5" strokeLinecap="round"/>
      <line x1="46.7" y1="-46.7" x2="31.1" y2="-31.1" stroke="#1D9E75" strokeWidth="4" strokeLinecap="round"/>
      <line x1="46.7" y1="46.7" x2="31.1" y2="31.1" stroke="#1D9E75" strokeWidth="4" strokeLinecap="round"/>
      <line x1="-46.7" y1="46.7" x2="-31.1" y2="31.1" stroke="#1D9E75" strokeWidth="4" strokeLinecap="round"/>
      <line x1="-46.7" y1="-46.7" x2="-31.1" y2="-31.1" stroke="#1D9E75" strokeWidth="4" strokeLinecap="round"/>
      <circle r="14" fill="#EF9F27"/>
      <circle r="5.5" fill="#06100A"/>
    </g>
  </svg>
);

// Laksh Logo - Full horizontal logo with text
export const LakshLogo = ({ height = 40, className = '', variant = 'dark' }) => {
  const textColor = variant === 'light' ? '#06100A' : '#FFFFFF';
  const scaleFactor = height / 100;
  
  return (
    <svg 
      width={400 * scaleFactor} 
      height={height} 
      viewBox="0 0 400 100" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(50,50)">
        <circle r="38" fill="none" stroke="#EF9F27" strokeWidth="4.5"/>
        <circle r="25" fill="none" stroke="#1D9E75" strokeWidth="2.2"/>
        <line x1="0" y1="-38" x2="0" y2="-27" stroke="#EF9F27" strokeWidth="4" strokeLinecap="round"/>
        <line x1="0" y1="27" x2="0" y2="38" stroke="#EF9F27" strokeWidth="4" strokeLinecap="round"/>
        <line x1="-38" y1="0" x2="-27" y2="0" stroke="#EF9F27" strokeWidth="4" strokeLinecap="round"/>
        <line x1="27" y1="0" x2="38" y2="0" stroke="#EF9F27" strokeWidth="4" strokeLinecap="round"/>
        <line x1="26.9" y1="-26.9" x2="17.7" y2="-17.7" stroke="#1D9E75" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="26.9" y1="26.9" x2="17.7" y2="17.7" stroke="#1D9E75" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="-26.9" y1="26.9" x2="-17.7" y2="17.7" stroke="#1D9E75" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="-26.9" y1="-26.9" x2="-17.7" y2="-17.7" stroke="#1D9E75" strokeWidth="2.5" strokeLinecap="round"/>
        <circle r="8.5" fill="#EF9F27"/>
        <circle r="3.5" fill="#06100A"/>
      </g>
      <text 
        x="108" 
        y="64" 
        fontFamily="'Outfit', 'Helvetica Neue', sans-serif" 
        fontSize="46" 
        fontWeight="700" 
        fill={textColor} 
        letterSpacing="-2"
      >
        Laksh
      </text>
    </svg>
  );
};

// Laksh Logo - Stacked version
export const LakshLogoStacked = ({ width = 120, className = '' }) => (
  <svg 
    width={width} 
    height={width * 1.4} 
    viewBox="0 0 200 280" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(100,100)">
      <circle r="76" fill="none" stroke="#EF9F27" strokeWidth="8"/>
      <circle r="50" fill="none" stroke="#1D9E75" strokeWidth="4.5"/>
      <line x1="0" y1="-76" x2="0" y2="-54" stroke="#EF9F27" strokeWidth="7.5" strokeLinecap="round"/>
      <line x1="0" y1="54" x2="0" y2="76" stroke="#EF9F27" strokeWidth="7.5" strokeLinecap="round"/>
      <line x1="-76" y1="0" x2="-54" y2="0" stroke="#EF9F27" strokeWidth="7.5" strokeLinecap="round"/>
      <line x1="54" y1="0" x2="76" y2="0" stroke="#EF9F27" strokeWidth="7.5" strokeLinecap="round"/>
      <line x1="53.7" y1="-53.7" x2="35.4" y2="-35.4" stroke="#1D9E75" strokeWidth="4.5" strokeLinecap="round"/>
      <line x1="53.7" y1="53.7" x2="35.4" y2="35.4" stroke="#1D9E75" strokeWidth="4.5" strokeLinecap="round"/>
      <line x1="-53.7" y1="53.7" x2="-35.4" y2="35.4" stroke="#1D9E75" strokeWidth="4.5" strokeLinecap="round"/>
      <line x1="-53.7" y1="-53.7" x2="-35.4" y2="-35.4" stroke="#1D9E75" strokeWidth="4.5" strokeLinecap="round"/>
      <circle r="16" fill="#EF9F27"/>
      <circle r="6.5" fill="#06100A"/>
    </g>
    <text 
      x="100" 
      y="240" 
      fontFamily="'Outfit', 'Helvetica Neue', sans-serif" 
      fontSize="46" 
      fontWeight="700" 
      fill="#FFFFFF" 
      letterSpacing="-2"
      textAnchor="middle"
    >
      Laksh
    </text>
  </svg>
);

// Brand colors export
export const brandColors = {
  darkGreen: '#06100A',
  saffron: '#EF9F27',
  emerald: '#1D9E75',
  white: '#FFFFFF',
};

export default LakshLogo;
